import { render, staticRenderFns } from "./UserProfileLink.vue?vue&type=template&id=8d539924&scoped=true&"
import script from "./UserProfileLink.vue?vue&type=script&lang=js&"
export * from "./UserProfileLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d539924",
  null
  
)

export default component.exports